<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Adicionar tarefa</h2>
      <FormTask @submit-requested="submitRequested"></FormTask>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormTask from '../forms/FormTask.vue'

  export default {
  components: { FormTask },
    methods: {
      ...mapActions('tasks', ['addTask']),
      submitRequested (inputTask) {
        this.addTask(inputTask);
      },
    }
  }
</script> 
 
<style scoped>
</style> 